import rootApi from '@utils/baseAPI/WrapperApi';

export const apiBlindTariff = (data) => rootApi.post('/depots/bind-tariff', data);

export const apiGetDepotsByPartner = (partnerId) =>
  rootApi.get('/depots', { params: { partner_id: partnerId, size: 9999, page: 0 } });
